export default __webpack_public_path__ + "static/media/cross.ec241298.svg";